import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';

import { UserType } from '../enums/user.enum';
import { AuthService } from '../services/auth.service';
import { FacilityContextService } from '../services/facility-context.service';

/** Ensures assigned facilities are resolved before shell child routes activate. */
export const facilityReadyGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const facilityContext = inject(FacilityContextService);

  if (auth.me()?.userType !== UserType.OrgUser) {
    return true;
  }

  if (facilityContext.facilitiesResolved()) {
    return true;
  }

  return facilityContext.loadAssignedFacilities().pipe(
    map(() => true),
    catchError(() => of(true))
  );
};
